const Footer = () => {
  return (
    <>
      <div className="Footer_Gap"></div>
      <div class="footer">
        <span>myFlix</span>
      </div>
    </>
  );
};

export default Footer;
